import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalDialogComponent } from '../components/modal-dialog/bprmodal-dialog.component';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Subscription, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BprDialogService {
  bsModalRef: BsModalRef;
  subscriptions: Subscription[] = [];

  constructor(private bsModalService: BsModalService) { }

  addDialog(initialState: any, size: string = 'modal-md'): Observable<any> {
    const ignoreBackdropClick = true;

    this.bsModalRef = this.bsModalService.show(ModalDialogComponent, {
      initialState,
      ignoreBackdropClick,
      class: initialState.modalSize ?? size
    });

    return this.bsModalService.onHide;
  }

  hide() {
    this.bsModalRef.hide();
  }
}
